<div class="files-list-download">
    <ul>
        <!-- TODO ngFor de subidos -->
        <li
            [ngClass]="{'selected': selected == i}"
            *ngFor="let file of files; let i = index;"
        >
            <core-helpers-box-list-item
            [mainText]="file.name +' (' + file.filesize + ')'"
            (onMainTextClick)="click(file, i)"
            [actionText]="'Download'"
            (onActionTextClick)="download(file)"
            [rightText]="file.extension"
            ></core-helpers-box-list-item>
        </li>
    </ul>
</div>
